"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initTrialSaving = void 0;
const taskSetup_1 = require("../../taskSetup");
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const taskStore_1 = require("../../../taskStore");
const recordCompletion_1 = require("./recordCompletion");
const logger_1 = require("../../../utils/logger");
const trials_1 = require("../trials");
const scoringHandler_1 = require("./scoringHandler");
const initTrialSaving = (config) => {
    if (config.displayElement) {
        // @ts-ignore
        taskSetup_1.jsPsych.opts.display_element = config.display_element;
    }
    // Extend jsPsych's on_finish and on_data_update lifecycle functions to mark the
    // run as completed and write data to Firestore, respectively.
    const extend = (fn, code) => function () {
        // eslint-disable-next-line prefer-rest-params
        fn.apply(fn, arguments);
        // eslint-disable-next-line prefer-rest-params
        code.apply(fn, arguments);
    };
    // @ts-ignore
    taskSetup_1.jsPsych.opts.on_finish = extend(taskSetup_1.jsPsych.opts.on_finish, () => {
        // Add finishing metadata to run doc
        // const finishingMetadata = {}
        // const { maxTimeReached, numIncorrect, maxIncorrect } = taskStore();
        // if (maxTimeReached) {
        //   finishingMetadata.reasonTaskEnded = 'Max Time'
        // } else if (numIncorrect >= maxIncorrect) {
        //   finishingMetadata.reasonTaskEnded = 'Max Incorrect Trials'
        // } else {
        //   finishingMetadata.reasonTaskEnded = 'Completed Task'
        // }
        // config.firekit.finishRun(finishingMetadata);
        config.firekit.finishRun();
    });
    // @ts-ignore
    taskSetup_1.jsPsych.opts.on_trial_finish = extend(taskSetup_1.jsPsych.opts.on_trial_finish, () => {
        if ((0, taskStore_1.taskStore)().maxTimeReached) {
            (0, trials_1.finishExperiment)();
        }
        // record completion at 80%
        if ((0, taskStore_1.taskStore)().testTrialCount >= (0, taskStore_1.taskStore)().totalTestTrials * 0.8) {
            (0, recordCompletion_1.recordCompletion)(config);
        }
        (0, taskStore_1.taskStore)('totalTrialCount', (0, taskStore_1.taskStore)().totalTrialCount + 1);
    });
    let scoringHandler = null;
    let scoreCallback = null;
    if (config.isRoarApp) {
        scoringHandler = new scoringHandler_1.ScoringHandler(config.task, config.scoringVersion, config.userMetadata);
        // Create closure that captures taskStore reference
        // Equivalent to RoarScore.computedScoreCallback
        scoreCallback = async (rawScores) => {
            scoringHandler.totalCorrect = (0, taskStore_1.taskStore)().totalCorrect;
            scoringHandler.irtEstimates = (0, taskStore_1.taskStore)().irtEstimates;
            return await scoringHandler.computedScoreCallback(rawScores);
        };
    }
    // @ts-ignore
    taskSetup_1.jsPsych.opts.on_data_update = extend(taskSetup_1.jsPsych.opts.on_data_update, (data) => {
        if (data.save_trial) {
            // save_trial is a flag that indicates whether the trial should
            // be saved to Firestore. No point in writing it to the db.
            // creating a deep copy to prevent modifying of original data
            // since it is used down the line for the rest of the pipeline
            const dataCopy = (0, cloneDeep_1.default)(data);
            delete dataCopy.save_trial;
            delete dataCopy.internal_node_id;
            delete dataCopy.button_response;
            delete dataCopy.response_source;
            dataCopy.responseSource = data.response_source;
            delete dataCopy.trial_type;
            dataCopy.trialIndex = dataCopy.trial_index;
            delete dataCopy.trial_index;
            dataCopy.taskId = (0, taskStore_1.taskStore)().task;
            if (config.isRoarApp) {
                config.firekit.writeTrial(dataCopy, scoreCallback);
            }
            else {
                config.firekit.writeTrial(dataCopy).catch((error) => {
                    delete dataCopy.stimulus; // remove stimulus from data to avoid logging large html elements
                    logger_1.Logger.getInstance().capture('Error writing trial to Firestore', { error: error, data: dataCopy });
                });
            }
        }
    });
};
exports.initTrialSaving = initTrialSaving;
